import {createStore} from 'trim-redux'
const state = {
    app_name : "Kolay Doy",
    navCollapsed : false,
    isAuth : false,
    user : null,
    locale : "fa",
    dir : "rtl",
    features : [],
    primary_color:'#F0051F',
    secondary_color:'#489E21',
    error:'',
    setting:[],
};
export const store = createStore(state);